import React from 'react'
import moment from 'moment'

const NumericalDate = ({
    value
}) => {
    if (!value) {
        return null
    }
    const text = moment(value).startOf('day').format('MM/DD/YYYY')
    return (<React.Fragment>{text}</React.Fragment>)
}

export default NumericalDate